import { render, staticRenderFns } from "./Consultations.vue?vue&type=template&id=67285fa0&scoped=true"
import script from "./Consultations.vue?vue&type=script&lang=js"
export * from "./Consultations.vue?vue&type=script&lang=js"
import style0 from "./Consultations.vue?vue&type=style&index=0&id=67285fa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67285fa0",
  null
  
)

export default component.exports